import React from 'react';

interface LogsIconProps {
  isActive?: boolean;
}

export const LogsIcon: React.FC<LogsIconProps> = ({ isActive = false }) => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M14 2H6C4.9 2 4 2.9 4 4V20C4 21.1 4.89 22 5.99 22H18C19.1 22 20 21.1 20 20V8L14 2Z"
        stroke={isActive ? "#1890ff" : "#8c8c8c"}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
      <path
        d="M14 2V8H20"
        stroke={isActive ? "#1890ff" : "#8c8c8c"}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
      <path
        d="M16 13H8"
        stroke={isActive ? "#1890ff" : "#8c8c8c"}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M16 17H8"
        stroke={isActive ? "#1890ff" : "#8c8c8c"}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10 9H8"
        stroke={isActive ? "#1890ff" : "#8c8c8c"}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
